'use client';

import { CreditCard } from 'lucide-react';

/** Espera del pago con tarjeta en la terminal del local. */
export function CheckoutWaitingTerminalStep() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-8 px-4 py-12 text-center">
      <div>
        <h3 className="mb-2 text-3xl font-bold">Pagá con tu tarjeta!</h3>
        <p className="text-lg text-muted-foreground">Una vez que el pago sea exitoso, tu pedido se procesará</p>
      </div>

      <div className="relative flex items-center justify-center py-8">
        <div className="absolute size-48 animate-ping rounded-full bg-orange-500/10" />
        <div className="absolute size-32 animate-pulse rounded-full bg-orange-500/20" />
        <div className="relative rotate-[-10deg] transform rounded-2xl border bg-white p-6 shadow-xl transition-transform hover:rotate-0">
          <CreditCard className="size-20 text-slate-800" />
        </div>
      </div>

      <h4 className="mt-4 max-w-sm text-xl font-bold">Acercá tu tarjeta a la terminal para completar el pago!</h4>

      <div className="mt-8">
        <p className="text-sm text-muted-foreground">
          Para cancelar el pago, presioná el botón de cancelar en el lector.
        </p>
      </div>
    </div>
  );
}
